module.exports = __webpack_public_path__ + "img/icon3.80deab7d.png";